import { memo } from 'react';
import { FormAsyncSelectFieldProps, lt } from '@mews/framework';
import { BillingSearchForReservationsForLinkingResult } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useGetAccountIsCompanySuspense } from '../../../accounts';
import { ReservationAsyncSelectSimple } from './ReservationAsyncSelectSimple';
import { ReservationAsyncSelectWithPreloadedReservationList } from './ReservationAsyncSelectWithPreloadedReservationList';

export interface WithReservationChangeCallback {
    onReservationChange?: ({
        defaultValue,
        finalDefaultValue,
    }: {
        defaultValue?: string | null;
        finalDefaultValue: string | null;
    }) => void;
}

interface ReservationSelectProps
    extends Omit<
        FormAsyncSelectFieldProps<BillingSearchForReservationsForLinkingResult>,
        'useDataQuery' | 'renderData'
    > {
    accountId: string;
    showFutureStayBanner?: boolean;
    showOnlyUnpaidReservations?: boolean;
}

export const ReservationAsyncSelect = memo(
    ({
        accountId,
        defaultValue,
        showOnlyUnpaidReservations = true,
        ...props
    }: ReservationSelectProps & WithReservationChangeCallback) => {
        const enterpriseId = useCurrentEnterpriseId();

        const { data: isAccountCompany } = useGetAccountIsCompanySuspense({ accountId });

        if (isAccountCompany) {
            return <ReservationAsyncSelectSimple {...props} accountId={accountId} />;
        }

        return (
            <ReservationAsyncSelectWithPreloadedReservationList
                {...props}
                helper={lt('ProcessPaymentLinkPaymentToReservationReservationSelectionHintNew')}
                accountId={accountId}
                enterpriseId={enterpriseId}
                showOnlyUnpaidReservations={showOnlyUnpaidReservations}
                defaultValue={defaultValue}
            />
        );
    }
);
